import { Mail } from "lucide-react";
import { PROTOCOL_STEPS, IMAGES, CONTACT_EMAIL } from "../data";
import { Breadcrumb } from "../Layout";

export default function Protocole() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-14 sm:px-8">
      <Breadcrumb items={[{ label: "Accueil", to: "/" }, { label: "Protocole" }]} />
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <p className="tag-mono mb-4 text-[#E4C5B3]">Guide d'application</p>
          <h1 className="font-display text-4xl font-medium leading-[1.1] tracking-tight sm:text-5xl">
            Le protocole d'application, de la manucure russe au top coat
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 sm:text-lg">
            Ce protocole reprend les recommandations d'application des gels de construction American Creator :
            préparation minutieuse, base dense, architecture, couleur et finition, avec les temps de catalysation.
          </p>
        </div>
        <div className="lg:col-span-5">
          <figure className="frame-editorial">
            <img
              src={IMAGES.prep.src}
              width={IMAGES.prep.width}
              height={IMAGES.prep.height}
              alt={IMAGES.prep.alt}
              loading="lazy"
              className="h-full w-full object-cover"
            />
          </figure>
        </div>
      </div>

      <ol className="mt-14 space-y-5">
        {PROTOCOL_STEPS.map((s) => (
          <li
            key={s.n}
            data-testid={`protocol-step-${s.n}`}
            className="grid grid-cols-1 gap-4 border border-white/10 bg-[#15151C] p-6 sm:grid-cols-12 sm:items-center sm:gap-6 sm:p-8"
          >
            <span className="font-display text-4xl text-[#E4C5B3]/60 sm:col-span-2">{s.n}</span>
            <div className="sm:col-span-7">
              <h2 className="font-display text-xl font-medium">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-zinc-400 sm:text-base">{s.desc}</p>
            </div>
            <span className="tag-mono border border-[#E4C5B3]/30 px-3 py-2 text-center text-[#E4C5B3] sm:col-span-3">
              {s.tag}
            </span>
          </li>
        ))}
      </ol>

      <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2">
        <figure className="frame-editorial">
          <img
            src={IMAGES.fraises.src}
            width={IMAGES.fraises.width}
            height={IMAGES.fraises.height}
            alt={IMAGES.fraises.alt}
            loading="lazy"
            className="h-full w-full object-cover"
          />
        </figure>
        <div className="border border-white/10 bg-[#15151C] p-8">
          <p className="tag-mono mb-3 text-[#E4C5B3]">Le bon embout</p>
          <h2 className="font-display text-2xl font-medium tracking-tight">La fraise diamant Cone Blue</h2>
          <p className="mt-4 text-base leading-relaxed text-zinc-400">
            Référence 115493 du fabricant KMIZ, cet embout diamant de 1,4 mm de diamètre est conçu pour le
            nettoyage des cuticules et la préparation de la plaque unguéale — la première étape du protocole.
            Vitesse optimale : 20 000 à 25 000 tours par minute.
          </p>
        </div>
      </div>

      <div className="mt-12 border border-[#E4C5B3]/25 bg-[#1C1C26] p-8 sm:p-10">
        <h2 className="font-display text-2xl font-medium tracking-tight">Une question sur un geste ou une référence ?</h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-zinc-400">
          Chaque gel a ses spécificités. Écrivez-nous pour un conseil d'application adapté à votre pratique.
        </p>
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="protocole-contact-cta" className="btn-primary mt-6">
          <Mail size={16} aria-hidden="true" /> {CONTACT_EMAIL}
        </a>
      </div>
    </div>
  );
}
